import { Request } from "@xt/xtbase";
const { XtAxios, XtAxios4 } = Request;

const generateFlatMethods = (baseUrl) => ({
  get: (url, data, config) => {
    config = config || {};
    const params = config.params || {};
    return XtAxios.get(`${baseUrl}${url}`, {
    ...config,
    params: {
      ...params,
      ...data,
    }
  })},
  del: (url, data, config) => {
    config = config || {};
    const params = config.params || {};

    return XtAxios.delete(`${baseUrl}${url}`, {
    ...config,
    params: {
      ...params,
      ...data,
    }
  })},
  put: (url, data, config) => XtAxios.put(`${baseUrl}${url}`, data, config),
  post: (url, data, config) => XtAxios.post(`${baseUrl}${url}`, data, config),
});

export default generateFlatMethods;
